<section class="term-selector">
	<h3 *ngIf="showTitle">¿A cuántos meses quieres pagarlo?</h3>
	<div class="term-selector__options">
		<button
			type="button"
			(click)="changePlazo(indx)"
			[attr.active]="plazo.active"
			*ngFor="let plazo of visiblePlazos; let indx = index">
			{{ plazo.val }} meses
		</button>
	</div>
</section>
